import React from 'react';
import classnames from 'classnames';

import SnapchatIcon from '../icons/SnapchatIcon';
import FacebookIcon from '../icons/FacebookIcon';
import TwitterIcon from '../icons/TwitterIcon';
import InstagramIcon from '../icons/InstagramIcon';
import TiktokIcon from '../icons/TiktokIcon';

import styles from './css/SocialMediaLinks.module.css';


function SocialMediaLinks(props) {
  const {
    hasSocialLinks,
    isNakedNewsLive,
    anchor,
    isPastAnchor,
  } = props;

  const shouldRenderLinks = hasSocialLinks && !isNakedNewsLive;
  const {
    snapchat,
    facebook,
    twitter,
    tiktok,
    instagram,
  } = anchor || {};

  if (!shouldRenderLinks) {
    return null;
  }

  return (
    <div
      className={classnames(
          styles.anchorBannerSocial, { [styles.pastAnchor]: isPastAnchor })
      }
    >
      <div className={styles.anchorBannerSocialIcons}>
        {snapchat &&
          <a className={styles.socialLinksIcon} href={snapchat} rel="noopener noreferrer" target="_blank">
            <SnapchatIcon />
          </a>
        }
        {facebook &&
          <a className={styles.socialLinksIcon} href={facebook} rel="noreferrer" target="_blank">
            <FacebookIcon />
          </a>
        }
        {twitter &&
          <a className={styles.socialLinksIcon} href={`http://twitter.com/${twitter}`} rel="noreferrer" target="_blank">
            <TwitterIcon />
          </a>
        }
        {instagram &&
          <a
            className={styles.socialLinksIcon}
            href={`http://instagram.com/${instagram}`}
            rel="noreferrer"
            target="_blank"
          >
            <InstagramIcon />
          </a>
        }
        {tiktok &&
          <a
            className={styles.socialLinksIcon}
            href={`http://www.tiktok.com/${tiktok}`}
            rel="noreferrer"
            target="_blank"
          >
            <TiktokIcon />
          </a>
        }
      </div>
    </div>
  );
}

export default SocialMediaLinks;
